import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_harvest_team/show_process/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },

  fetchHarvestTeamWorkLogsTotal(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_harvest_team/show_process/${organization_id}/fetch_harvest_team_work_logs_total/${harvest_process_id}`
    );
  },

  fetchHarvestTeamWorkLogs(organization_id, harvest_process_id, current_page, rows_per_page) {
    return RequesterV1.get(
      `organization/production/productivity_by_harvest_team/show_process/${organization_id}/fetch_harvest_team_work_logs/${harvest_process_id}/${current_page}/${rows_per_page}`
    );
  },

  fetchAvailableMonths(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_harvest_team/show_process/${organization_id}/fetch_available_months/${harvest_process_id}`
    );
  },

  syncData(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_harvest_team/show_process/${organization_id}/sync_data/${harvest_process_id}`
    );
  },

  downloadRepByProcessXlsx(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_harvest_team/show_process/${organization_id}/download_rep_by_process_xlsx/${harvest_process_id}`,
      { responseType: "blob" }
    );
  },

  downloadRepByMonthXlsx(organization_id, harvest_process_id, year, month) {
    return RequesterV1.get(
      `organization/production/productivity_by_harvest_team/show_process/${organization_id}/download_rep_by_month_xlsx/${harvest_process_id}/${year}/${month}`,
      { responseType: "blob" }
    );
  }
};
